export const search = (
  <path
    d="M17.5499 17.5533C20.4788 14.6244 20.4788 9.87563 17.5499 6.9467C14.621 4.01777 9.87224 4.01777 6.94331 6.9467C4.01438 9.87563 4.01438 14.6244 6.94331 17.5533C9.87224 20.4822 14.621 20.4822 17.5499 17.5533ZM17.5499 17.5533L23.9139 23.9173"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  />
);
